import config from "../config";
import PlatformError from "../PlatformError";

export default new PlatformError("ERROR", config.defaultMessage, "SetupError", "Invalid domain included in setup", config.defaultMessageId)
